document.addEventListener('DOMContentLoaded', function() {
  // Array of menu items that should have soundwaves
  const targetMenuItems = [
    'DSP AMPS',
      'AMPLIFIERS',
      
'DSP PROCESSORS',
    'SPEAKERS',
        'BMW DIRECT-FIT',
            'MERCEDES-BENZ DIRECT-FIT',
    'POWERED SUBWOOFERS',
  
   
    'ACCESSORIES',
        'MANUALS',
    // Add more menu items here as needed
  ];
  
  // Function to create soundwave HTML
  function createSoundWave() {
    const soundWave = document.createElement('div');
    soundWave.className = 'sound-wave';
    
    // Add sound bars to the wave
    for (let i = 0; i < 17; i++) {
      const bar = document.createElement('div');
      bar.className = 'sound-bar';
      
      // Randomize animation delay for a more natural effect
      bar.style.animationDelay = `${Math.random() * 0.5}s`;
      
      soundWave.appendChild(bar);
    }
    
    return soundWave;
  }
  
  // Find all menu items with reversed-link class
  const navItems = document.querySelectorAll('.reversed-link');
  
  navItems.forEach(item => {
    // Get the text content of the menu item (remove extra whitespace)
    const itemText = item.textContent.trim();
    
    // Check if this menu item is in our target list
 const shouldHaveSoundwave = targetMenuItems.some(targetItem => 
  itemText === targetItem
);
    
    if (shouldHaveSoundwave) {
      // Skip if already has a sound wave (prevents duplicates)
      if (item.querySelector('.sound-wave') !== null) {
        return;
      }
      
      // Create and append the soundwave
      const soundWave = createSoundWave();
      item.appendChild(soundWave);
    }
  });
});





















document.addEventListener("DOMContentLoaded", function () {
  const tabButtons = document.querySelectorAll(
    "#shopify-section-template--25533851107626__tabs_content_8rnbnj .tabs__tab"
  );

  // Filter visible, non-empty tab buttons
  const visibleTabs = [...tabButtons].filter(
    (btn) => btn.innerText.trim() !== "" && !btn.classList.contains("hidden")
  );

  if (visibleTabs.length === 0) {
    // Hide Optional Accessories section by ID
    const optionalSection = document.querySelector(
      "#shopify-section-template--25533851107626__rich_text_eNTtBw"
    );

    if (optionalSection) {
      optionalSection.style.display = "none";
    }
  }
});

